import moment, { Moment } from "moment-timezone";
import { BetQLSportItem } from "src/common-services";
import {
  // COLUMN_DATE,
  COLUMN_TEAMS,
  COLUMN_CURRENT,
  COLUMN_OPEN,
  COLUMN_VALUE_RATING,
  COLUMN_PUBLIC_TICKET_PCT,
  COLUMN_PUBLIC_MONEY,
  COLUMN_LINE_MOVE_SPREAD,
  COLUMN_INJURIES,
  COLUMN_PRO_MONEY_EDGE,
  COLUMN_TOTAL_GAMES,
  COLUMN_LINE_MOVE_ML,
  COLUMN_LINE_MOVE_OU,
  COLUMN_UNDER_RECORD,
  COLUMN_SEASON_WIN_PCT,
  COLUMN_ATS_RECORD,
  COLUMN_ATS_WIN_PCT,
  COLUMN_OVER_RECORD,
  COLUMN_OVER_PCT,
  COLUMN_UNDER_PCT,
  COLUMN_ROT_NUMBER,
  COLUMN_CURRENT_SPREAD,
  COLUMN_OPEN_SPREAD,
  COLUMN_CURRENT_ML,
  COLUMN_OPEN_ML,
  COLUMN_CURRENT_OU,
  COLUMN_OPEN_OU,
  COLUMN_PUBLIC_TICKET_TOT_SPREAD,
  COLUMN_PUBLIC_TICKET_TOT_ML,
  COLUMN_PUBLIC_TICKET_TOT_OVER,
  COLUMN_PUBLIC_TICKET_TOT_UNDER,
  COLUMN_NET_UNITS,
  COLUMN_ATS_UNITS,
  COLUMN_PITCHERS,
  COLUMN_PTS_FOR,
  COLUMN_PTS_AGAINST,
  COLUMN_HOME_RECORD,
  COLUMN_ROAD_RECORD,
  COLUMN_HOME_ATS_RECORD,
  COLUMN_ROAD_ATS_RECORD,
  COLUMN_HOME_OU_RECORD,
  COLUMN_ROAD_OU_RECORD,
  COLUMN_LINE_MOVE,
  COLUMN_BETQL_MODEL,
  COLUMN_BETQL_COMMUNITY,
  COLUMN_SHARP_BETTING,
  COLUMN_FADE_THE_PUBLIC,
  COLUMN_CONSENSUS,
} from "../../../constants";
import { TrendPick } from "src/services/EventService";

/**
 *
 * @param columnId The columnId that we will be sorting by
 * @param eventA An event we will compare with another event
 * @param eventB An event we will compare with another event
 * @param betType The betType key
 * @param currentSportObj The sport configuration object
 */
export const getColumnSort = (
  columnId: number,
  eventA: any,
  eventB: any,
  betType: string,
  currentSportObj: BetQLSportItem,
  columnSortDesc: boolean
) => {
  const periodFilter =
    betType === "spread" || betType === "moneyline" || betType === "total" ? `FG${betType}` : betType;
  switch (columnId) {
    case COLUMN_PUBLIC_TICKET_PCT:
      return sortByEventStat(eventA, eventB, `sharp${periodFilter}TicketData`, columnSortDesc);
    case COLUMN_LINE_MOVE:
      return sortByEventStat(eventA, eventB, `movement${periodFilter}Data`, columnSortDesc);
    case COLUMN_LINE_MOVE_SPREAD:
      return sortByEventStat(eventA, eventB, "movementFGspreadData", columnSortDesc);
    case COLUMN_LINE_MOVE_ML:
      return sortByEventStat(eventA, eventB, "movementFGmoneylineData", columnSortDesc);
    case COLUMN_LINE_MOVE_OU:
      return sortByEventStat(eventA, eventB, "movementFGtotalData", columnSortDesc);
    case COLUMN_VALUE_RATING:
      return sortValueRating(eventA, eventB, betType, currentSportObj, columnSortDesc);
    case COLUMN_PRO_MONEY_EDGE:
      return sortByEventStat(eventA, eventB, `sharp${periodFilter}Data`, columnSortDesc);
    case COLUMN_ROT_NUMBER:
      return sortByEventStat(eventA, eventB, "awayRot", columnSortDesc);
    case COLUMN_CURRENT:
      return sortByTeamStat(
        eventA,
        eventB,
        `current${periodFilter}AwayData`,
        `current${periodFilter}HomeData`,
        columnSortDesc
      );
    case COLUMN_OPEN:
      return sortByTeamStat(
        eventA,
        eventB,
        `open${periodFilter}AwayData`,
        `open${periodFilter}HomeData`,
        columnSortDesc
      );
    case COLUMN_PUBLIC_MONEY:
      return sortByTeamStat(
        eventA,
        eventB,
        `sharp${periodFilter}PublicAwayData`,
        `sharp${periodFilter}PublicHomeData`,
        columnSortDesc
      );
    case COLUMN_TOTAL_GAMES:
      return sortByTeamStat(eventA, eventB, "statAwayTeamGamesData", "statHomeTeamGamesData", columnSortDesc);
    case COLUMN_UNDER_RECORD:
      return sortByTeamRecord(
        eventA,
        eventB,
        "statAwayTeamUndersData",
        "statAwayTeamOversData",
        "statHomeTeamUndersData",
        "statHomeTeamOversData",
        columnSortDesc
      );
    case COLUMN_SEASON_WIN_PCT:
      return sortByTeamStat(eventA, eventB, "statAwayTeamWinPercentData", "statHomeTeamWinPercentData", columnSortDesc);
    case COLUMN_ATS_RECORD:
      return sortByTeamRecord(
        eventA,
        eventB,
        "statAwayTeamATSWinsData",
        "statAwayTeamATSLossesData",
        "statHomeTeamATSWinsData",
        "statHomeTeamATSLossesData",
        columnSortDesc
      );
    case COLUMN_ATS_WIN_PCT:
      return sortByTeamStat(
        eventA,
        eventB,
        "statAwayTeamATSWinPercentData",
        "statHomeTeamATSWinPercentData",
        columnSortDesc
      );
    case COLUMN_OVER_RECORD:
      return sortByTeamRecord(
        eventA,
        eventB,
        "statAwayTeamOversData",
        "statAwayTeamUndersData",
        "statHomeTeamOversData",
        "statHomeTeamUndersData",
        columnSortDesc
      );
    case COLUMN_OVER_PCT:
      return sortByTeamStat(
        eventA,
        eventB,
        "statAwayTeamOverPercentData",
        "statHomeTeamOverPercentData",
        columnSortDesc
      );
    case COLUMN_UNDER_PCT:
      return sortByTeamStat(
        eventA,
        eventB,
        "statAwayTeamUnderPercentData",
        "statHomeTeamUnderPercentData",
        columnSortDesc
      );
    case COLUMN_CURRENT_SPREAD:
      return sortByTeamStat(eventA, eventB, "currentFGspreadAwayData", "currentFGspreadHomeData", columnSortDesc);
    case COLUMN_OPEN_SPREAD:
      return sortByTeamStat(eventA, eventB, "openFGspreadAwayData", "openFGspreadHomeData", columnSortDesc);
    case COLUMN_CURRENT_ML:
      return sortByTeamStat(eventA, eventB, "currentFGmoneylineAwayData", "currentFGmoneylineHomeData", columnSortDesc);
    case COLUMN_OPEN_ML:
      return sortByTeamStat(eventA, eventB, "openFGmoneylineAwayData", "openFGmoneylineHomeData", columnSortDesc);
    case COLUMN_CURRENT_OU:
      return sortByTeamStat(eventA, eventB, "currentFGtotalAwayData", "currentFGtotalHomeData", columnSortDesc);
    case COLUMN_OPEN_OU:
      return sortByTeamStat(eventA, eventB, "openFGtotalAwayData", "openFGtotalHomeData", columnSortDesc);
    case COLUMN_PUBLIC_TICKET_TOT_SPREAD:
      return sortByTeamStat(eventA, eventB, "sharpFGspreadCountAwayData", "sharpFGspreadCountHomeData", columnSortDesc);
    case COLUMN_PUBLIC_TICKET_TOT_ML:
      return sortByTeamStat(
        eventA,
        eventB,
        "sharpFGmoneylineCountAwayData",
        "sharpFGmoneylineCountHomeData",
        columnSortDesc
      );
    case COLUMN_PUBLIC_TICKET_TOT_OVER:
      return sortByTeamStat(eventA, eventB, "sharpFGtotalCountAwayData", "", columnSortDesc);
    case COLUMN_PUBLIC_TICKET_TOT_UNDER:
      return sortByTeamStat(eventA, eventB, "sharpFGtotalCountHomeData", "", columnSortDesc);
    case COLUMN_NET_UNITS:
      return sortByTeamStat(eventA, eventB, "statAwayTeamNetUnitsData", "statHomeTeamNetUnitsData", columnSortDesc);
    case COLUMN_ATS_UNITS:
      return sortByTeamStat(eventA, eventB, "statAwayTeamATSUnitsData", "statHomeTeamATSUnitsData", columnSortDesc);
    case COLUMN_PTS_FOR:
      return sortByTeamStat(eventA, eventB, "statAwayTeamPointsForData", "statHomeTeamPointsForData", columnSortDesc);
    case COLUMN_PTS_AGAINST:
      return sortByTeamStat(
        eventA,
        eventB,
        "statAwayTeamPointsAgainstData",
        "statHomeTeamPointsAgainstData",
        columnSortDesc
      );
    case COLUMN_HOME_RECORD:
      return sortByTeamRecord(
        eventA,
        eventB,
        "statAwayTeamHomeWinsData",
        "statAwayTeamHomeLossesData",
        "statHomeTeamHomeWinsData",
        "statHomeTeamHomeLossesData",
        columnSortDesc
      );
    case COLUMN_ROAD_RECORD:
      return sortByTeamRecord(
        eventA,
        eventB,
        "statAwayTeamRoadWinsData",
        "statAwayTeamRoadLossesData",
        "statHomeTeamRoadWinsData",
        "statHomeTeamRoadLossesData",
        columnSortDesc
      );
    case COLUMN_HOME_ATS_RECORD:
      return sortByTeamRecord(
        eventA,
        eventB,
        "statAwayTeamHomeATSWinsData",
        "statAwayTeamHomeATSLossesData",
        "statHomeTeamHomeATSWinsData",
        "statHomeTeamHomeATSLossesData",
        columnSortDesc
      );
    case COLUMN_ROAD_ATS_RECORD:
      return sortByTeamRecord(
        eventA,
        eventB,
        "statAwayTeamRoadATSWinsData",
        "statAwayTeamRoadATSLossesData",
        "statHomeTeamRoadATSWinsData",
        "statHomeTeamRoadATSLossesData",
        columnSortDesc
      );
    case COLUMN_HOME_OU_RECORD:
      return sortByTeamRecord(
        eventA,
        eventB,
        "statAwayTeamHomeOUWinsData",
        "statAwayTeamHomeOULossesData",
        "statHomeTeamHomeOUWinsData",
        "statHomeTeamHomeOULossesData",
        columnSortDesc
      );
    case COLUMN_ROAD_OU_RECORD:
      return sortByTeamRecord(
        eventA,
        eventB,
        "statAwayTeamRoadOUWinsData",
        "statAwayTeamRoadOULossesData",
        "statHomeTeamRoadOUWinsData",
        "statHomeTeamRoadOULossesData",
        columnSortDesc
      );
    case COLUMN_BETQL_MODEL:
    case COLUMN_BETQL_COMMUNITY:
    case COLUMN_SHARP_BETTING:
    case COLUMN_FADE_THE_PUBLIC:
    case COLUMN_CONSENSUS:
      return sortByTrendPick(eventA, eventB);
    case COLUMN_TEAMS:
    case COLUMN_INJURIES:
    case COLUMN_PITCHERS:
    // case COLUMN_DATE:
    // eslint-disable-next-line no-fallthrough
    default:
      return sortByDate(eventA, eventB, columnSortDesc);
  }
};

const sortByTrendPick = (eventA: any, eventB: any) => {
  const trendEventA: TrendPick = eventA.trendsPick;
  const trendEventB: TrendPick = eventB.trendsPick;

  const totalCountA = trendEventA.awayCount + trendEventA.homeCount + trendEventA.drawCount;
  const totalCountB = trendEventB.awayCount + trendEventB.homeCount + trendEventB.drawCount;
  const maxCountA = Math.max(trendEventA.awayCount, trendEventA.homeCount, trendEventA.drawCount);
  const maxCountB = Math.max(trendEventB.awayCount, trendEventB.homeCount, trendEventB.drawCount);
  const favoredTeamA = trendEventA.favoredTeam;
  const favoredTeamB = trendEventB.favoredTeam;

  // The one with a winning trend come first
  if (favoredTeamA && !favoredTeamB) {
    return -1;
  }

  if (!favoredTeamA && favoredTeamB) {
    return 1;
  }

  // We get the max trend pick for one team and sort by that next
  if (maxCountA > maxCountB) {
    return -1;
  }

  if (maxCountA < maxCountB) {
    return 1;
  }

  // We get the max trend pick for one team and sort by that next
  if (totalCountA > totalCountB) {
    return -1;
  }

  if (totalCountA < totalCountB) {
    return 1;
  }

  return 0;
};

/**
 * This will sort events by teams with the highest net record difference (wins - losses)
 *
 * Example: Team that's 10-8 will be +2, team that's 7-12 will be -5. (+2) - (-5) = 7
 * Highest net difference sorts first
 *
 * @param eventA
 * @param eventB
 * @param winStat
 * @param lossStat
 * @param desc
 */
const sortByTeamRecord = (
  eventA: any,
  eventB: any,
  awayWinStat: string,
  awayLossStat: string,
  homeWinStat: string,
  homeLossStat: string,
  desc: boolean
) => {
  const eventAwayNetRecordA = eventA[awayWinStat] - eventA[awayLossStat];
  const eventHomeNetRecordA = eventA[homeWinStat] - eventA[homeLossStat];
  const eventAwayNetRecordB = eventB[awayWinStat] - eventB[awayLossStat];
  const eventHomeNetRecordB = eventB[homeWinStat] - eventB[homeLossStat];
  if (desc) {
    const eventRecordA = eventAwayNetRecordA > eventHomeNetRecordA ? eventAwayNetRecordA : eventHomeNetRecordA;
    const eventRecordB = eventAwayNetRecordB > eventHomeNetRecordB ? eventAwayNetRecordB : eventHomeNetRecordB;
    if (eventRecordA > eventRecordB) {
      return -1;
    }
    if (eventRecordA < eventRecordB) {
      return 1;
    }
  } else {
    const eventRecordA = eventAwayNetRecordA < eventHomeNetRecordA ? eventAwayNetRecordA : eventHomeNetRecordA;
    const eventRecordB = eventAwayNetRecordB < eventHomeNetRecordB ? eventAwayNetRecordB : eventHomeNetRecordB;
    if (eventRecordA < eventRecordB) {
      return -1;
    }
    if (eventRecordA > eventRecordB) {
      return 1;
    }
  }
  return 0;
};

/**
 * Determine if the awayTeam or homeTeam has the lessor value, then sort the events
 * by which has the most negative value.
 *
 * @param eventA One event we will be comparing
 * @param eventB Another event we will be comparing
 * @param awayStat The awayTeam stat key to use
 * @param homeStat The homeTeam stat key to use
 * @param desc Sort by descending numbers
 */
const sortByTeamStat = (eventA: any, eventB: any, awayStat: string, homeStat: string, desc: boolean) => {
  if (desc) {
    const awayDataA = eventA[awayStat] || null;
    const homeDataA = eventA[homeStat] || null;
    const awayDataB = eventB[awayStat] || null;
    const homeDataB = eventB[homeStat] || null;

    let eventStatA = awayDataA > homeDataA ? awayDataA : homeDataA;
    let eventStatB = awayDataB > homeDataB ? awayDataB : homeDataB;
    if (eventStatA !== null && eventStatB === null) {
      return -1;
    }
    if (eventStatA === null && eventStatB !== null) {
      return 1;
    }
    if (eventStatA > eventStatB) {
      return -1;
    }
    if (eventStatA < eventStatB) {
      return 1;
    }
  } else {
    // NOTE: Since null equates to 0, lets set null values to a large number so that
    // they they are never chosen as the lowest value. An example where this is helpful
    // is when we are sorting by totals. The currentFGtotalHomeData is always going to be null
    // so we always want to take the away stat.
    const awayDataA = eventA[awayStat] || Infinity;
    const homeDataA = eventA[homeStat] || Infinity;
    const awayDataB = eventB[awayStat] || Infinity;
    const homeDataB = eventB[homeStat] || Infinity;
    let eventStatA = awayDataA < homeDataA ? awayDataA : homeDataA;
    let eventStatB = awayDataB < homeDataB ? awayDataB : homeDataB;
    if (eventStatA !== null && eventStatB === null) {
      return -1;
    }
    if (eventStatA === null && eventStatB !== null) {
      return 1;
    }
    if (eventStatA < eventStatB) {
      return -1;
    }
    if (eventStatA > eventStatB) {
      return 1;
    }
  }
  return sortByDate(eventA, eventB, false);
};

/**
 * Sort events by the highest stat value
 *
 * @param eventA One event we will be comparing
 * @param eventB Another event we will be comparing
 * @param stat The stat we are comparing
 * @param desc Sort by descending numbers
 */
const sortByEventStat = (eventA: any, eventB: any, stat: string, desc: boolean) => {
  if (eventA[stat] !== null && eventB[stat] === null) {
    return -1;
  }
  if (eventA[stat] === null && eventB[stat] !== null) {
    return 1;
  }
  if (desc) {
    if (eventA[stat] > eventB[stat]) {
      return -1;
    }
    if (eventA[stat] < eventB[stat]) {
      return 1;
    }
  } else {
    if (eventA[stat] < eventB[stat]) {
      return -1;
    }
    if (eventA[stat] > eventB[stat]) {
      return 1;
    }
  }
  return sortByDate(eventA, eventB, false);
};

/**
 * Sort events by date
 *
 * @param eventA One event we will be comparing
 * @param eventB Another event we will be comparing
 * @param desc Sort by descending numbers
 */
const sortByDate = (eventA: any, eventB: any, desc: boolean) => {
  const startMomentA: Moment = moment(eventA.startDate);
  const startMomentB: Moment = moment(eventB.startDate);
  if (desc) {
    if (startMomentA.isAfter(startMomentB)) {
      return -1;
    }
    if (startMomentA.isBefore(startMomentB)) {
      return 1;
    }
  } else {
    if (startMomentA.isBefore(startMomentB)) {
      return -1;
    }
    if (startMomentA.isAfter(startMomentB)) {
      return 1;
    }
  }
  return 0;
};

/**
 * Sort events by the greated best bet rating for the corresponding betType
 *
 * @param eventA One event we will be comparing
 * @param eventB Another event we will be comparing
 * @param betType The betType to use for determining which value to compare
 * @param currentSportObj The current sport configuration object
 * @param desc Sort by descending numbers
 */
const sortValueRating = (eventA: any, eventB: any, betType: string, currentSportObj: BetQLSportItem, desc: boolean) => {
  const periodFilter =
    betType === "spread" || betType === "moneyline" || betType === "total" ? `FG${betType}` : betType;
  const isNew = currentSportObj[`has${periodFilter}PowerRating`];
  const trendKey = `max${isNew ? "New" : ""}${periodFilter}Trend`;
  const dataA =
    trendKey && eventA[trendKey] !== null && eventA[trendKey] !== undefined ? eventA[trendKey].displayRating : 0;
  const dataB =
    trendKey && eventB[trendKey] !== null && eventB[trendKey] !== undefined ? eventB[trendKey].displayRating : 0;
  // Sort by Rating first
  if (desc) {
    if (dataA > dataB) {
      return -1;
    }
    if (dataA < dataB) {
      return 1;
    }
  } else {
    if (dataA < dataB) {
      return -1;
    }
    if (dataA > dataB) {
      return 1;
    }
  }
  // Sort by the absolute value of the differential (show green arrow games first)
  // Only sort by differential if the rating is greater than a 1 star
  if (isNew && dataA > 1 && dataB > 1) {
    const differentialA = Math.abs(eventA[`value${periodFilter}Differential`]);
    const differentialB = Math.abs(eventB[`value${periodFilter}Differential`]);
    if (differentialA > differentialB) {
      return -1;
    }
    if (differentialA < differentialB) {
      return 1;
    }
  }
  // Sort by date
  return sortByDate(eventA, eventB, false);
};
